module.exports = __webpack_public_path__ + "227190d1fe778a97104cf8438db85764.svg";